import { useState, useEffect, useCallback } from "react";
import { getDepartments } from "api/departments";
import { getDesignations } from "api/designation";
import { getBranches, getShiftsByBranch } from "api/branches";

export const useDropdownOptions = () => {
  const [dropdownOptions, setDropdownOptions] = useState({
    departments: [],
    designations: [],
    branches: [],
    shifts: [],
  });
  const [loading, setLoading] = useState(true);

  // Initial load for departments, designations, and branches
  useEffect(() => {
    const fetchDropdownOptions = async () => {
      try {
        setLoading(true);
        const [departmentsRes, designationsRes, branchesRes] = await Promise.all([
          getDepartments(1, 100),
          getDesignations(1, 100),
          getBranches(1, 100),
        ]);

        setDropdownOptions((prev) => ({
          ...prev,
          departments: departmentsRes.data || [],
          designations: designationsRes.data || [],
          branches: branchesRes.data || [],
          shifts: [], // Don't fetch shifts initially
        }));
      } catch (error) {
        console.error("Error fetching dropdown options:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchDropdownOptions();
  }, []);

  // ✅ Memoize the shift fetching function to avoid infinite re-renders
const fetchShiftsForBranch = useCallback(async (branchId) => {
  try {
    if (!branchId) {
      setDropdownOptions((prev) => ({
        ...prev,
        shifts: [],
      }));
      return;
    }

    const shiftsRes = await getShiftsByBranch(branchId);
console.log(shiftsRes)
    // ✅ Deep copy or change object structure to force re-render
    const newShifts = (shiftsRes.shifts || []).map((shift) => ({ ...shift }));

    console.log(newShifts)

    setDropdownOptions((prev) => ({
      ...prev,
      shifts: newShifts, // forces array reference to be new
    }));
  } catch (error) {
    console.error("Error fetching shifts by branch:", error);
  }
}, []);


  return { dropdownOptions, loading, fetchShiftsForBranch };
};
